import { gsap } from "gsap";

// Variable globale pour stocker l'observateur actif
// Cela permet de le déconnecter proprement avant de changer de page
let counterObserver = null;

window.initPdwCounter = function () {
    // 1. NETTOYAGE (Vital pour Barba)
    // Si un observateur existe déjà (page précédente), on le détruit.
    if (counterObserver) {
        counterObserver.disconnect();
        counterObserver = null;
    }

    // Sélection des éléments
    const counters = document.querySelectorAll('.gsap-counter');
    if (counters.length === 0) return;

    // 2. FONCTION D'ANIMATION
    const animateCounter = (element) => {
        // Empêche l'animation de se lancer deux fois sur le même élément
        if (element.classList.contains('is-animated')) return;
        element.classList.add('is-animated');

        const originalText = element.getAttribute('data-original');
        const targetValue = parseFloat(element.getAttribute('data-target')) || 0;

        // Analyse regex (inchangée, elle est solide)
        const match = originalText ? originalText.match(/^([^0-9]*)([0-9.,]+)(.*)$/) : null;
        const prefix = match ? match[1] : "";
        const numberStr = match ? match[2] : "";
        const suffix = match ? match[3] : "";

        // Détection Float vs Int
        const isFloat = targetValue % 1 !== 0 || (numberStr.includes(',') && targetValue < 1000);

        let proxyObj = { value: 0 };

        gsap.to(proxyObj, {
            value: targetValue,
            duration: 2.5,
            ease: "power2.out",
            onUpdate: function () {
                const current = proxyObj.value;
                let formattedNumber;

                if (isFloat) {
                    // Gestion décimale (remplace le point par virgule si l'original en avait une)
                    formattedNumber = current.toFixed(1);
                    if (numberStr.includes(',')) {
                        formattedNumber = formattedNumber.replace('.', ',');
                    }
                } else {
                    // Gestion Entier
                    formattedNumber = Math.round(current);

                    // Gestion séparateur de milliers (Point ou Espace)
                    if (numberStr.includes('.')) {
                        // Style Européen: 1.500
                        formattedNumber = formattedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    } else if (numberStr.includes(' ')) {
                        // Style Français moderne: 1 500
                        formattedNumber = formattedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                    }
                }

                element.textContent = prefix + formattedNumber + suffix;
            },
            onComplete: function () {
                // Remet le texte exact pour éviter les petits décalages d'arrondi
                element.textContent = originalText;
            }
        });
    };

    // 3. CRÉATION DE L'OBSERVATEUR
    counterObserver = new IntersectionObserver((entries, self) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateCounter(entry.target);
                // On arrête d'observer cet élément précis une fois animé
                self.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.2 // 20% visible suffit (plus réactif que 0.5)
    });

    // 4. LANCEMENT
    counters.forEach(counter => {
        counterObserver.observe(counter);
    });
};

// Initialisation hors de la fonction
document.addEventListener("DOMContentLoaded", () => {
    window.initPdwCounter();
});